var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import md5 from "md5";
import Component from "vue-class-component";
import SvgIcon from "~/components/common/svg-icon.vue";
import AppConfig from "~/config/app.config";
import { Dependencies } from "~/core/decorator";
import { State, Mutation, Action, namespace } from "vuex-class";
import { StorageService } from "~/utils/storage.service";
import { UserService } from "~/services/manage-service/user.service";
import { CollectionCaseService } from "~/services/domain-service/collection-case.service";
var workspaceModule = namespace("workspace");
var Login = /** @class */ (function (_super) {
    __extends(Login, _super);
    function Login() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loginRule = {
            username: {
                required: true,
                message: "员工工号不能为空",
                trigger: "blur",
            },
            password: {
                required: true,
                message: "密码不能为空",
                trigger: "blur",
            },
        };
        _this.loginModel = {
            username: "",
            password: "",
            agent: "",
            customer: "C284",
            deptName: "",
        };
        _this.appConfig = AppConfig;
        _this.remember = false;
        _this.dialog = {
            workPassword: false,
        };
        return _this;
    }
    Login.prototype.mounted = function () {
        var rember = StorageService.getItem("remember");
        this.remember = !!rember;
        if (rember) {
            this.loginModel = rember;
        }
    };
    /**
     * 提交登录表单
     */
    Login.prototype.submitForm = function () {
        var _this = this;
        var loginForm = this.$refs["login-form"];
        loginForm.validate(function (success) {
            if (!success)
                return;
            if (_this.remember) {
                StorageService.setItem("remember", _this.loginModel);
            }
            else {
                StorageService.removeItem("remember");
            }
            _this.userService
                .login({
                username: _this.loginModel.username,
                password: _this.loginModel.password,
            })
                .subscribe(function (_a) {
                var token = _a.token, userModel = _a.userModel, departmentModel = _a.departmentModel;
                _this.updateUserLoginData({
                    token: token,
                    userModel: userModel,
                });
                var admin = _this.menuResource.find(function (v) { return v.name === "首页"; });
                _this.updateCurrentTopMenu(admin);
                var agent = "";
                if ("MS-WXX" == _this.loginModel.username) {
                    agent = "9343";
                }
                else if ("MS-PLP" == _this.loginModel.username) {
                    agent = "9296";
                }
                else if ("MS_HX" == _this.loginModel.username) {
                    agent = "8907";
                }
                else if ("MS-YM" == _this.loginModel.username) {
                    agent = "8933";
                }
                else if ("MS_MFF" == _this.loginModel.username) {
                    agent = "9294";
                }
                else if ("MS-WLF" == _this.loginModel.username) {
                    agent = "9297";
                }
                else if ("MS_wh" == _this.loginModel.username) {
                    agent = "9293";
                }
                else if ("MS_ZRL" == _this.loginModel.username) {
                    agent = "8934";
                }
                else if ("MS_zcc" == _this.loginModel.username) {
                    agent = "8911";
                }
                else if ("MS-LDY" == _this.loginModel.username) {
                    agent = "15877";
                }
                else if ("MS_DYM" == _this.loginModel.username) {
                    agent = "8924";
                }
                else if ("MS_LQS" == _this.loginModel.username) {
                    agent = "8925";
                }
                else if ("MS-YY" == _this.loginModel.username) {
                    agent = "8927";
                }
                else if ("MS_ZCY" == _this.loginModel.username) {
                    agent = "8926";
                }
                else if ("MS_WJ" == _this.loginModel.username) {
                    agent = "8931";
                }
                else if ("MS-MXQ" == _this.loginModel.username) {
                    agent = "9344";
                }
                else if ("MS_YB" == _this.loginModel.username) {
                    agent = "15685";
                }
                else if ("MS-ZKY" == _this.loginModel.username) {
                    agent = "8923";
                }
                else if ("MS_ZR" == _this.loginModel.username) {
                    agent = "9499";
                }
                else if ("MS_ZDS" == _this.loginModel.username) {
                    agent = "8922";
                }
                else if ("MS_LYY" == _this.loginModel.username) {
                    agent = "8918";
                }
                else if ("MS_ZXP" == _this.loginModel.username) {
                    agent = "8908";
                }
                else if ("MS_HWX" == _this.loginModel.username) {
                    agent = "8906";
                }
                else if ("MS_ZZJ" == _this.loginModel.username) {
                    agent = "8935";
                }
                else if ("MS_YXW" == _this.loginModel.username) {
                    agent = "9386";
                }
                else if ("MS_ZY" == _this.loginModel.username) {
                    agent = "12595";
                }
                else if ("MS_YJM" == _this.loginModel.username) {
                    agent = "12596";
                }
                else if ("MS_XYJ" == _this.loginModel.username) {
                    agent = "9501";
                }
                else if ("MS_ZCJ" == _this.loginModel.username) {
                    agent = "9500";
                }
                else if ("MS_wwj" == _this.loginModel.username) {
                    agent = "8912";
                }
                else if ("MS_hmm" == _this.loginModel.username) {
                    agent = "8932";
                }
                else if ("MS-HP" == _this.loginModel.username) {
                    agent = "8035";
                }
                else if ("MS_WJY" == _this.loginModel.username) {
                    agent = "13098";
                }
                else if ("MS_PJ" == _this.loginModel.username) {
                    agent = "9295";
                }
                else if ("MS-ZL" == _this.loginModel.username) {
                    agent = "13100";
                }
                else if ("MS-XSQ" == _this.loginModel.username) {
                    agent = "10400";
                }
                else if ("MS_ZQ" == _this.loginModel.username) {
                    agent = "8928";
                }
                else if ("MS_ZQ" == _this.loginModel.username) {
                    agent = "8928";
                }
                else if ("MS_LY" == _this.loginModel.username) {
                    agent = "8925";
                }
                else if ("MS_LX" == _this.loginModel.username) {
                    agent = "15874";
                }
                else if ("MS-DSQ" == _this.loginModel.username) {
                    agent = "8931";
                }
                else if ("MS-XLX" == _this.loginModel.username) {
                    agent = "8926";
                }
                else if ("MS_LG" == _this.loginModel.username) {
                    agent = "8923";
                }
                else if ("MS_ZZX" == _this.loginModel.username) {
                    agent = "8922";
                }
                else if ("MS_ZZX" == _this.loginModel.username) {
                    agent = "8922";
                }
                else if ("MS-WX" == _this.loginModel.username) {
                    agent = "8929";
                }
                else if ("MS-WX" == _this.loginModel.username) {
                    agent = "8929";
                }
                else if ("MS_WR" == _this.loginModel.username) {
                    agent = "15876";
                }
                else if ("MS_HYY" == _this.loginModel.username) {
                    agent = "15875";
                }
                else if ("MS-ZJF" == _this.loginModel.username) {
                    agent = "8927";
                }
                else if ("MS-PL" == _this.loginModel.username) {
                    agent = "8924";
                }
                else if ("MS_WQH" == _this.loginModel.username) {
                    agent = "8930";
                }
                else if ("MS_JT" == _this.loginModel.username) {
                    agent = "8937";
                }
                _this.loginModel.agent = agent;
                _this.loginModel.deptName = departmentModel.name;
                _this.setAgent(agent);
                StorageService.setItem("userInfoStage", _this.loginModel);
                // 跳转工作区
                if (userModel) {
                    _this.$router.push("/dashboard/dashboard-bulletin");
                }
                else {
                    _this.$router.push("/");
                }
            }, function (_a) {
                var msg = _a.msg;
            });
        });
    };
    Login.prototype.setAgent = function (agent) {
        var that = this;
        var ts = String(Date.now());
        var signStr = md5("C284@" + ts + "@5271@F3F60809078BCB9BFA66B03BF5912010");
        console.log(ts);
        console.log(signStr);
        var myObj = {
            "authentication": {
                "customer": "C284",
                "timestamp": ts,
                "seq": "5271",
                "digest": signStr,
            },
            "request": {
                "seq": "5271",
                "userData": "ASD123",
                "agent": agent,
            },
        };
        var myJSON = JSON.stringify(myObj);
        var httpRequest = new XMLHttpRequest(); //第一步：建立所需的对象
        httpRequest.open("POST", "https://ft.liansdk.com/assetsManager/hjxt/agentSetIdle", true);
        httpRequest.setRequestHeader("Content-type", "application/json");
        httpRequest.send(myJSON);
        httpRequest.onreadystatechange = function () {
            if (httpRequest.readyState == 4 && httpRequest.status == 200) {
                var json2 = httpRequest.responseText; //获取到json字符串，还需解析
                console.log(json2);
            }
        };
        return;
    };
    __decorate([
        Dependencies(CollectionCaseService)
    ], Login.prototype, "collectionCaseService", void 0);
    __decorate([
        Dependencies(UserService)
    ], Login.prototype, "userService", void 0);
    __decorate([
        State
    ], Login.prototype, "menuResource", void 0);
    __decorate([
        Mutation
    ], Login.prototype, "updateCurrentTopMenu", void 0);
    __decorate([
        Action("updateUserLoginData")
    ], Login.prototype, "updateUserLoginData", void 0);
    __decorate([
        workspaceModule.State
    ], Login.prototype, "currentTabs", void 0);
    __decorate([
        workspaceModule.Mutation("updateCurrentTabs")
    ], Login.prototype, "updateCurrentTabs", void 0);
    Login = __decorate([
        Component({
            components: {
                SvgIcon: SvgIcon,
            },
        })
    ], Login);
    return Login;
}(Vue));
export default Login;
